import script from "./ClinicianStudentTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./ClinicianStudentTable.vue?vue&type=script&lang=ts&setup=true"

import "./ClinicianStudentTable.vue?vue&type=style&index=0&id=b4b94de8&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b4b94de8"]])

export default __exports__